import React from 'react';

const ProfileIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#F2F8FD" />
      <path
        d="M16 16C18.7614 16 21 13.7614 21 11C21 8.23858 18.7614 6 16 6C13.2386 6 11 8.23858 11 11C11 13.7614 13.2386 16 16 16Z"
        fill="#333333"
      />
      <path
        d="M15.9999 18.5C10.9899 18.5 6.90991 21.86 6.90991 26C6.90991 26.28 7.12991 26.5 7.40991 26.5H24.5899C24.8699 26.5 25.0899 26.28 25.0899 26C25.0899 21.86 21.0099 18.5 15.9999 18.5Z"
        fill="#333333"
      />
    </svg>
  );
};

export default ProfileIcon;
